/**
 * O app Android na Play Store — fonte única do link e da chave que liga os convites para baixá-lo
 * (a tarja da Home, pages/Home/TarjaApp.jsx, o selo do rodapé, components/Footer.jsx, e o do
 * Login, pages/Login.jsx).
 *
 * `publicado` vem do build (.env, REACT_APP_APP_ANDROID_PUBLICADO): enquanto o app estiver em teste
 * fechado, a página da loja não abre para quem não é testador, e convidar o visitante para um link
 * que dá "item não encontrado" é pior do que não convidar. Virou true, precisa de build novo.
 *
 * O `referrer` com utm_source/utm_medium é o que o Play Console lê nos relatórios de aquisição: é
 * por ele que dá para separar quem instalou pela tarja de quem instalou pelo rodapé.
 */
const URL_LOJA = 'https://play.google.com/store/apps/details?id=br.com.novafaxina.app&hl=pt_BR';

/**
 * A página do app dentro do app da Play Store, para o "Atualizar" de components/AvisoVersaoApp. É o
 * esquema que abre direto no app da loja, com o botão de atualizar, e não no navegador.
 */
export const ESQUEMA_LOJA = 'market://details?id=br.com.novafaxina.app';

export const appAndroidPublicado = () => process.env.REACT_APP_APP_ANDROID_PUBLICADO === 'true';

/** `origem` identifica o ponto do site que mandou para a loja ('tarja-home', 'rodape'). */
export const urlDaLoja = (origem) =>
	`${URL_LOJA}&referrer=${encodeURIComponent(`utm_source=site&utm_medium=${origem}`)}`;
